<cdk-virtual-scroll-viewport class="h-100 scrollbar-visible" itemSize="100">
  <div class="search-container iubenda-padding">
    @if (loaded) {
      <div class="p-3 pl-5 pr-5 catalog">
        @if (isCopyingConfiguration() && searchItems?.length) {
          <div class="copying-container">
            <div class="copying-label">
              {{ 'SELECT_TO_COPY' | translate }}
              <span class="copying-label-cancel" (click)="cancelCopyingConfiguration()">
                {{ 'ANNULLA' | translate }}
              </span>
            </div>
          </div>
        }

        @if (products?.length && pagination.offset > 0) {
          <div class="row text-center">
            <div class="col-sm-12">
              <button (click)="searchUndo()" class="button-secondary undo col-sm-12 col-md-6">
                {{ 'TORNA_INDIETRO' | translate }}
              </button>
            </div>
          </div>
        }

        @if (searchItems?.length) {
          <div class="model-container">
            @for (
                item of searchItems;
              track item.type === 'composer' ? item.composer.slugModular : item.product.productId
              ) {
              @if (item.type === 'composer') {
                <app-composer-card [model]="item.composer"></app-composer-card>
              }

              @if (item.type === 'product') {
                <div
                  (click)="modelDetail(item.product)"
                  class="model"
                  [class.last-searched-item]="item.product.productId === lastSearchedItem"
                >
                  <div class="img-container">
                    <img
                      [hidden]="!item.product.imageLoaded"
                      (load)="imageLoaded(item.product)"
                      [alt]="item.product?.productName"
                      [src]="convertProductImage(item.product)"
                      (error)="convertProductImage(item.product, true)"
                      class="model-image"
                    />
                  </div>

                  <p class="model-name">{{ item.product?.productName | titlecase }}</p>
                </div>
              }
            }
          </div>
        }

        @if (products?.length && showMore) {
          <div class="row text-center">
            <div class="col-sm-12">
              <button (click)="searchMore()" class="button-secondary show-more col-sm-12 col-md-6">
                {{ 'MOSTRA_ALTRI' | translate }}
              </button>
            </div>
          </div>
        }
      </div>
    }

    @if (!loaded) {
      <app-visionnaire-loader class="ipe:w-full" />
    }
  </div>

  @if (!searchItems?.length) {
    <div class="search-result">
      @if (lastFilters) {
        <p>{{ 'NO_SEARCH_RESULTS' | translate }}</p>
      }
      @if (!lastFilters) {
        <p>{{ 'FILTRI_RICERCA_DESC' | translate }}</p>
      }
    </div>
  }
</cdk-virtual-scroll-viewport>
